// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListLanguagesQueryVariables = Types.Exact<{
  pageNumber: Types.InputMaybe<Types.Scalars['Int']['input']>;
  pageSize: Types.InputMaybe<Types.Scalars['Int']['input']>;
  keyword: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type ListLanguagesQuery = { __typename?: 'Query' } & {
  listLanguages: { __typename?: 'ListLanguages' } & Pick<Types.ListLanguages, 'totalCount'> & {
      items: Array<{ __typename?: 'Language' } & Pick<Types.Language, 'code' | 'displayName'>>;
    };
};

export const ListLanguagesDocument = /*#__PURE__*/ gql`
    query listLanguages($pageNumber: Int, $pageSize: Int, $keyword: String) {
  listLanguages(
    filter: {pageNumber: $pageNumber, pageSize: $pageSize, keyword: $keyword}
  ) {
    items {
      code
      displayName
    }
    totalCount
  }
}
    `;

/**
 * __useListLanguagesQuery__
 *
 * To run a query within a React component, call `useListLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLanguagesQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useListLanguagesQuery(
  baseOptions?: Apollo.QueryHookOptions<ListLanguagesQuery, ListLanguagesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListLanguagesQuery, ListLanguagesQueryVariables>(ListLanguagesDocument, options);
}
export function useListLanguagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListLanguagesQuery, ListLanguagesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListLanguagesQuery, ListLanguagesQueryVariables>(ListLanguagesDocument, options);
}
// @ts-expect-error
export function useListLanguagesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListLanguagesQuery, ListLanguagesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListLanguagesQuery, ListLanguagesQueryVariables>;
export function useListLanguagesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLanguagesQuery, ListLanguagesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListLanguagesQuery | undefined, ListLanguagesQueryVariables>;
export function useListLanguagesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLanguagesQuery, ListLanguagesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListLanguagesQuery, ListLanguagesQueryVariables>(ListLanguagesDocument, options);
}
export type ListLanguagesQueryHookResult = ReturnType<typeof useListLanguagesQuery>;
export type ListLanguagesLazyQueryHookResult = ReturnType<typeof useListLanguagesLazyQuery>;
export type ListLanguagesSuspenseQueryHookResult = ReturnType<typeof useListLanguagesSuspenseQuery>;
